import { types as QTypes } from "../components/questionnaire/types";
import questionService from "src/api/questionnaire-service";
import $ajax from "src/utils/ajax.js";

export default {
  /**获取验证码 */
  getCode(id) {
    let params = Object.assign({}, this.auth, {
      id: id,
    });
    return $ajax.$get(questionService.GET_QUESTIONNAIRE_ID(), params);
  },
  /**获取区域json数据 */
  getAreaData() {
    let params = Object.assign({}, this.auth);
    return $ajax.$get(questionService.GET_AREA_JSON, params);
  },
  /**批量指定ID的问卷数据 */
  getById(id) {
    let params = Object.assign({}, this.auth, {
      id: id,
    });
    return $ajax.$get(questionService.GET_QUESTIONNAIRE_ID(), params);
  },
  /**批量获取多个问卷数据 */
  getByIds(arr) {
    let ids = arr.join(",");
    let params = Object.assign({}, this.auth, {
      ids: ids,
    });
    return $ajax.$get(questionService.GET_QUESTIONNAIRE_IDS(), params);
  },
  /**保存问卷数据 */
  save(data) {
    console.log("save:", JSON.stringify(data));
    let _data = JSON.parse(JSON.stringify(data));
    _data.detail.forEach((item) => {
      item.ext = JSON.stringify(item.ext);
    });
    _data.detail = JSON.stringify(_data.detail);

    let params = Object.assign({}, this.auth, _data);
    if (_data.id) {
      delete params.publish;
      return $ajax.$post(questionService.POST_UPDATE_QUESTIONNAIRE(), params);
    } else {
      return $ajax.$post(questionService.POST_CREATE_QUESTIONNAIRE(), params);
    }
  },
  /**提交问卷数据 */
  submit(data) {
    let params = Object.assign({}, this.auth, data);
    console.log(this.auth, data, 5);

    return $ajax.$post(questionService.POST_SUBMIT_QUESTIONNAIRE(), params);
  },
  /**发布问卷 */
  publish(id) {
    let params = Object.assign({}, this.auth, { id: id });
    return $ajax.$post(questionService.POST_PUBLISH_QUESTIONNAIRE(), params);
  },
  /**取消发布问卷 */
  cancelPublish(id) {
    let params = Object.assign({}, this.auth, {
      id: id,
    });
    return $ajax.$post(
      questionService.POST_CANCEL_PUBLISH_QUESTIONNAIRE(),
      params
    );
  },
  /**校验保存问卷数据合法性 */
  validate(data) {
    let result = {
      state: true,
      msg: "",
    };
    if (!data.title) {
      result.state = false;
      result.msg = "问卷标题不能为空";
    }
    data.detail.forEach((item) => {
      if (!item.title) {
        result.state = false;
        result.msg = "问卷标题不能为空";
        return false;
      }
      if (
        item.type === QTypes.RADIO ||
        item.type === QTypes.CHECKBOX ||
        item.type === QTypes.SELECT
      ) {
        let result = true;
        item.detail.list.forEach((item) => {
          if (!item.value || (item.error && item.value === "请设置选项")) {
            result = false;
            item.value = "请设置选项";
            item.error = true;
          } else {
            delete item.error;
          }
        });
        if (!result) {
          result.state = false;
          result.msg = "选项不能为空";
          return false;
        }
      }
      if (item.type === QTypes.MATRIX) {
        let result = true;
        item.detail.row.forEach((item) => {
          if (!item.value || (item.error && item.value === "请设置选项")) {
            result = false;
            item.value = "请设置选项";
            item.error = true;
          } else {
            delete item.error;
          }
        });
        item.detail.column.forEach((item) => {
          if (!item.value || (item.error && item.value === "请设置选项")) {
            result = false;
            item.value = "请设置选项";
            item.error = true;
          } else {
            delete item.error;
          }
        });
        if (!result) {
          result.state = false;
          result.msg = "选项不能为空";
          return false;
        }
      }
    });
    return result;
  },
  check(data) {},
  /**发送验证码 */
  sendPhoneCode(params) {
    return $ajax.$post(questionService.POST_sendPhoneCode(), params);
  },
  /**发送验证码 */
  validatorPhoneCode(params) {
    return $ajax.$post(questionService.POST_validatorPhoneCode(), params);
  },
};
